export const myStudioBasicProductID = '5fe1393f-e871-42e9-b544-fc8f73fcffb6';
export const myStudioExpandedProductID = 'fe275d5a-bda8-4579-b07c-d22412d19dc1';